import React from 'react';
import { TextField, Button } from '../../layout';
import { useAuth } from '../../hooks/useAuth';

const ClientForm = ({
    formData,
    handleInputChange,
    errors,
    agents,
    currentClient,
    handleSubmit,
    onCancel,
    readOnly = false
}) => {
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';
    return (
        <form onSubmit={handleSubmit}>
            <fieldset disabled={readOnly} style={readOnly ? { opacity: 1 } : undefined}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField
                    id="CustSupp"
                    name="CustSupp"
                    label="Codice Cliente"
                    value={formData.CustSupp}
                    onChange={handleInputChange}
                    error={errors.CustSupp}
                    required
                    disabled={!!currentClient}
                />
                <TextField
                    id="CompanyName"
                    name="CompanyName"
                    label="Ragione Sociale"
                    value={formData.CompanyName}
                    onChange={handleInputChange}
                    error={errors.CompanyName}
                    required
                />
                <TextField
                    id="TaxIdNumber"
                    name="TaxIdNumber"
                    label="Partita IVA"
                    value={formData.TaxIdNumber}
                    onChange={handleInputChange}
                    error={errors.TaxIdNumber}
                    required
                />

                <div className="form-group">
                    <label htmlFor="PriceList" className="block text-sm font-medium text-gray-700 mb-1">
                        Listino Prezzi
                    </label>
                    <select
                        id="PriceList"
                        name="PriceList"
                        value={formData.PriceList}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border border-gray-200 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50"
                    >
                        <option value="PR">PR (Italia)</option>
                        <option value="PR-E">PR-E (Estero)</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="Language" className="block text-sm font-medium text-gray-700 mb-1">
                        Lingua
                    </label>
                    <select
                        id="Language"
                        name="Language"
                        value={formData.Language}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border border-gray-200 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50"
                    >
                        <option value="IT">Italiano</option>
                        <option value="EN">Inglese</option>
                        <option value="FR">Francese</option>
                        <option value="DE">Tedesco</option>
                        <option value="ES">Spagnolo</option>
                    </select>
                </div>

                <TextField
                    id="DiscountFormula"
                    name="DiscountFormula"
                    label="Formula Sconto"
                    value={formData.DiscountFormula}
                    onChange={handleInputChange}
                    error={errors.DiscountFormula}
                    helperText="Es: 10+5, 15, ecc."
                />

                <TextField
                    id="Address"
                    name="Address"
                    label="Indirizzo"
                    value={formData.Address}
                    onChange={handleInputChange}
                />
                <TextField
                    id="ZIPCode"
                    name="ZIPCode"
                    label="CAP"
                    value={formData.ZIPCode}
                    onChange={handleInputChange}
                />
                <TextField
                    id="City"
                    name="City"
                    label="Città"
                    value={formData.City}
                    onChange={handleInputChange}
                />
                <TextField
                    id="County"
                    name="County"
                    label="Provincia"
                    value={formData.County}
                    onChange={handleInputChange}
                />
                <TextField
                    id="Region"
                    name="Region"
                    label="Regione"
                    value={formData.Region}
                    onChange={handleInputChange}
                />

                <div className="form-group">
                    <label htmlFor="Salesperson" className="block text-sm font-medium text-gray-700 mb-1">
                        Agente <span className="text-red-500">*</span>
                    </label>
                    <select
                        id="Salesperson"
                        name="Salesperson"
                        value={formData.Salesperson}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border ${errors.Salesperson ? 'border-red-300' : 'border-gray-200'} rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50`}
                        required
                    >
                        <option value="">Seleziona agente</option>
                        {agents.map(agent => (
                            <option key={agent.Salesperson} value={agent.Salesperson}>
                                {agent.Name} ({agent.Salesperson})
                            </option>
                        ))}
                    </select>
                    {errors.Salesperson && (
                        <div className="flex items-center mt-1 text-sm text-red-600">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.Salesperson}
                        </div>
                    )}
                </div>

                <div className="form-group">
                    <label htmlFor="CustomerClassification" className="block text-sm font-medium text-gray-700 mb-1">
                        Classificazione Cliente
                    </label>
                    <select
                        id="CustomerClassification"
                        name="CustomerClassification"
                        value={formData.CustomerClassification || '002'}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border border-gray-200 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50"
                    >
                        <option value="002">Cliente</option>
                        <option value="001">Partner</option>
                    </select>
                </div>

                <TextField
                    id="Payment"
                    name="Payment"
                    label="Tipo Pagamento"
                    value={formData.Payment}
                    onChange={handleInputChange}
                    error={errors.Payment}
                />

                <TextField
                    id="MAIL"
                    name="MAIL"
                    label="Email"
                    type="email"
                    value={formData.MAIL || ''}
                    onChange={handleInputChange}
                    helperText="Email principale del cliente"
                />

                <TextField
                    id="TELEFONO"
                    name="TELEFONO"
                    label="Telefono"
                    value={formData.TELEFONO || ''}
                    onChange={handleInputChange}
                />

                <TextField
                    id="email"
                    name="email"
                    label="Email Login"
                    type="email"
                    value={formData.email || ''}
                    onChange={handleInputChange}
                    error={errors.email}
                    helperText="Email per accesso all'app (se diversa)"
                />

                <TextField
                    id="EMAIL_PERORDINE"
                    name="EMAIL_PERORDINE"
                    label="Email per Ordine"
                    type="email"
                    value={formData.EMAIL_PERORDINE || ''}
                    onChange={handleInputChange}
                />

                <TextField
                    id="EMAIL_PEROFFERTA01"
                    name="EMAIL_PEROFFERTA01"
                    label="Email per Offerta 1"
                    type="email"
                    value={formData.EMAIL_PEROFFERTA01 || ''}
                    onChange={handleInputChange}
                />

                <TextField
                    id="EMAIL_PEROFFERTA02"
                    name="EMAIL_PEROFFERTA02"
                    label="Email per Offerta 2"
                    type="email"
                    value={formData.EMAIL_PEROFFERTA02 || ''}
                    onChange={handleInputChange}
                />

                {isAdmin && (
                    <>
                        <TextField
                            id="password"
                            name="password"
                            label="Password"
                            type="password"
                            value={formData.password || ''}
                            onChange={handleInputChange}
                            error={errors.password}
                            helperText={formData.hasPassword ? "Password già impostata. Inserisci una nuova password solo se vuoi modificarla." : "Password per accesso cliente"}
                            placeholder={formData.hasPassword ? "••••••••" : ""}
                        />

                        <div className="form-group">
                            <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">
                                Ruolo
                            </label>
                            <select
                                id="role"
                                name="role"
                                value={formData.role || 'client'}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border border-gray-200 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50"
                            >
                                <option value="client">Cliente</option>
                                <option value="admin">Amministratore</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="is_active" className="block text-sm font-medium text-gray-700 mb-1">
                                Stato Account
                            </label>
                            <select
                                id="is_active"
                                name="is_active"
                                value={formData.is_active !== undefined ? formData.is_active : 1}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border border-gray-200 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50"
                            >
                                <option value="1">Attivo</option>
                                <option value="0">Disabilitato</option>
                            </select>
                            <p className="mt-1 text-sm text-gray-500">
                                Se disabilitato, il cliente non potrà effettuare il login
                            </p>
                        </div>
                    </>
                )}
            </div>

            </fieldset>
            <div className="mt-6 flex justify-end space-x-3">
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={onCancel}
                >
                    {readOnly ? "Chiudi" : "Annulla"}
                </Button>
                {!readOnly && (
                    <Button
                        type="submit"
                        color="primary"
                    >
                        {currentClient ? "Aggiorna" : "Salva"}
                    </Button>
                )}
            </div>
        </form>
    );
};

export default ClientForm;